import React from "react";

export const linkList = [
  { raw: <li id="teconsent"></li> },
  {
    label: "Terms of Use",
    url: "https://www.marriott.com/about/terms-of-use.mi",
  },
  {
    label: "Program Terms & Conditions",
    url: "https://www.marriott.com/loyalty/terms/default.mi",
  },
  {
    label: "Privacy Center",
    url: "https://www.marriott.com/about/privacy.mi",
  },
  { raw: <li id="ccpacontainer"></li> },
  {
    label: "Digital Accessibility",
    url: "https://www.marriott.com/digital-accessibility.mi",
  },
  {
    label: "Help",
    url: "https://help.marriott.com/s",
  },
];
